import { isStaging } from '@pn/core/utils/env';
import { isNil } from 'lodash-es';
import React from 'react';
import { notificationService } from 'src/application/externalDependencies';

const INTERVAL_MS = 10_000;
const MAX_TIMEOUT_MS = 3_000;

export function useInternetCheck() {
  const failedAttempts = React.useRef(0);

  React.useEffect(() => {
    if (!isStaging()) return;

    let isMounted = true;

    async function ping() {
      try {
        await fetchWithTimeout('https://staging.petroniche.com/ping.txt');
        if (isMounted) {
          failedAttempts.current = 0;
          notificationService.remove('internet-check');
        }
      } catch {
        if (isMounted) {
          failedAttempts.current += 1;
          if (failedAttempts.current >= 2) {
            if (!isNil(notificationService.get('internet-check'))) return;
            notificationService.render({
              content: 'Poor internet connection may affect app performance',
              options: {
                id: 'internet-check',
                showCloseButton: true,
              },
            });
          }
        }
      }
    }

    const interval = setInterval(ping, INTERVAL_MS);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);
}

async function fetchWithTimeout(
  url: string,
  timeoutMs = MAX_TIMEOUT_MS
): Promise<Response> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, {
      signal: controller.signal,
      mode: 'no-cors',
    });
  } finally {
    clearTimeout(timeoutId);
  }
}
